import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { DATEPICKER_KEY } from "../../../components/survey-widgets/datepicker-widget";

export const projectPlanConfig: PageConfig[] = [
  {
    name: "projectPlanType",
    title: "Project Plan",
    questions: [
      {
        type: "radiogroup",
        name: "projectPlanType",
        title: "You need to provide a project plan",
        choices: [
          { value: "file", text: "I will upload a project plan file" },
          {
            value: "inline",
            text: "I will enter details into this form directly",
          },
        ],
        isRequired: true,
      },
    ],
  },
  {
    name: "planUpload",
    title: "Project Plan Upload",
    visibleIf: "{projectPlanType} = 'file'",
    questions: [
      {
        type: "file",
        name: "planUpload",
        title: "Please upload a project plan",
        storeDataAsText: false,
        allowMultiple: false,
        maxSize: 10485760,
        waitForUpload: true,
        startWithNewLine: true,
        isRequired: true,
      },
    ],
  },
  {
    name: "planInline",
    title: "Project Plan Entry",
    visibleIf: "{projectPlanType} = 'inline'",
    questions: [
      {
        type: DATEPICKER_KEY,
        inputType: "date",
        name: "startDate",
        title: "Start Date",
        isRequired: true,
      },
      {
        type: DATEPICKER_KEY,
        inputType: "date",
        name: "endDate",
        title: "End Date",
        startWithNewLine: false,
      },
      {
        type: DATEPICKER_KEY,
        inputType: "date",
        name: "deliveryDate",
        title: "Delivery Date",
        startWithNewLine: false,
      },
      {
        type: "text",
        name: "delivery",
        title: "Who is responsible for delivering this initiative?",
        placeHolder: "Mā wai e mahi?",
        isRequired: true,
      },
      {
        type: "text",
        name: "deliveryPlatform",
        title: "Location or platform for delivery",
        placeHolder: "Mā pēhea e mahi?",
        isRequired: true,
        startWithNewLine: false,
      },
    ],
  },
  {
    name: "planSteps",
    title: "Project Plan Steps",
    visibleIf: "{projectPlanType} = 'inline'",
    questions: [
      {
        type: "comment",
        name: "planStepsPreparation",
        title: "Steps that will need to be taken in preparation",
        placeHolder: "Me aha kia rite?",
      },
      {
        type: "comment",
        name: "planStepsPlanning",
        title: "Steps that will need to be taken during planning",
        placeHolder: "Me aha kia whakamahere?",
      },
      {
        type: "comment",
        name: "planStepsDelivery",
        title: "Steps that will need to be taken during delivery",
        placeHolder: "Me aha kia mahi?",
      },
    ],
  },
  {
    name: "planOther",
    title: "Project Plan Other",
    visibleIf: "{projectPlanType} = 'inline'",
    questions: [
      {
        type: "comment",
        name: "planStepsOther",
        title: "Provide any other relevant details",
        placeHolder: "He aha kē?",
      },
    ],
  },
  {
    name: "projectSize",
    title: "Initiative Size",
    questions: [
      {
        type: "text",
        name: "requestedAmount",
        title:
          "Please indicate the amount of pūtea you are seeking from this application.",
        validators: [
          { type: "numeric" },
          {
            type: "expression",
            text: "$8,000 is the maximum amount able to be requested",
            expression: "{requestedAmount} < 8001",
          },
        ],
        isRequired: true,
      },
      {
        type: "expression",
        name: "initiativeSize",
        title: "Size of Initiative",
        expression:
          "iif({requestedAmount} > 2500, '$2,500 - $8,000', iif({requestedAmount}, '< $2,500', ''))",
      },
    ],
  },
];
